var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2006_27378)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.179688,
    width: 32.1797,
    height: 32.1797,
    rx: 12.0674,
    fill: "#F6EFFB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M19.0997 22.9734H13.0794C10.7263 22.9734 10.2168 21.6259 10.4112 19.9767L11.0146 14.9486C11.1688 13.648 11.3967 12.582 13.6761 12.582H18.5031C20.7825 12.582 21.0104 13.648 21.1646 14.9486L21.6674 19.1386L21.768 19.9767C21.7747 20.0303 21.7814 20.0839 21.7881 20.1375C21.9289 21.713 21.3791 22.9734 19.0997 22.9734Z",
    fill: "#A461D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7714 14.0867C18.4965 14.0867 18.2686 13.8587 18.2686 13.5839V11.2374C18.2686 10.5134 17.8194 10.0642 17.0953 10.0642H15.0841C14.3601 10.0642 13.9109 10.5134 13.9109 11.2374V13.5839C13.9109 13.8587 13.6829 14.0867 13.4081 14.0867C13.1332 14.0867 12.9053 13.8587 12.9053 13.5839V11.2374C12.9053 9.95694 13.8036 9.05859 15.0841 9.05859H17.0953C18.3758 9.05859 19.2742 9.95694 19.2742 11.2374V13.5839C19.2742 13.8587 19.0462 14.0867 18.7714 14.0867Z",
    fill: "#A461D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7882 20.1356C21.7681 20.1423 21.748 20.1423 21.7279 20.1423H13.4081C13.1332 20.1423 12.9053 19.9144 12.9053 19.6395C12.9053 19.358 13.1332 19.1367 13.4081 19.1367H21.6675L21.7681 19.9747C21.7748 20.0284 21.7815 20.082 21.7882 20.1356Z",
    fill: "#A461D8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2006_27378"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.179688,
    width: 32.1797,
    height: 32.1797,
    rx: 16.0898,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBag);
export default __webpack_public_path__ + "static/media/shopping-bag.6b3660598a9cf7e2cf7d682ad6b2ce62.svg";
export { ForwardRef as ReactComponent };